import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white overflow-x-hidden">
      <PublicNav />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-testid="about-content">
        <div className="eyebrow text-[#4B5773]">About</div>
        <h1 className="font-display text-4xl sm:text-5xl text-[#0B1A36] mt-2">Why we built NextRota.</h1>

        <div className="prose prose-slate max-w-none mt-8 text-[#1F2A44] leading-relaxed">
          <p>
            Most rostering tools are either spreadsheets that nobody enjoys editing,
            or enterprise platforms that take months to set up. We built NextRota
            for the businesses in between - small and growing teams that need a
            calm, modern way to plan the working week.
          </p>
          <h2 className="font-display text-2xl text-[#0B1A36] mt-10">What we care about</h2>
          <ul className="space-y-2">
            <li><strong>Helping businesses simplify workforce scheduling.</strong> Quick to learn, quick to publish, fewer surprises.</li>
            <li><strong>Reducing manual administration.</strong> Repeating patterns, bulk apply, automatic email notifications, copy-from-last-week.</li>
            <li><strong>Improving visibility and planning.</strong> Utilisation reports, leave calendars, bank-holiday awareness.</li>
            <li><strong>Future innovation in workforce management.</strong> A roadmap that includes skill-based scheduling, coverage gap detection and fair work-allocation.</li>
          </ul>
          <h2 className="font-display text-2xl text-[#0B1A36] mt-10">Where we're heading</h2>
          <p>
            Our north star is a workforce optimisation platform that learns from how
            your team actually works and quietly removes the busywork. Founding
            customers help us decide what to build next - including the AI and
            automation capabilities listed on our roadmap.
          </p>
          <p>
            If you'd like to talk shop, share feedback, or request a feature,
            we'd love to hear from you - <a href="mailto:hello@nextrota.com" className="text-[#2563EB]">hello@nextrota.com</a>.
          </p>
        </div>

        <div className="mt-12">
          <Link to="/start" data-testid="about-cta"
            className="inline-flex items-center px-6 py-3 rounded-md bg-[#2563EB] text-white font-semibold hover:bg-[#1D4ED8]">
            Start Free Trial
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
